import { render, staticRenderFns } from "./RoomsRatesButtons.vue?vue&type=template&id=03d310da&"
import script from "./RoomsRatesButtons.vue?vue&type=script&lang=js&"
export * from "./RoomsRatesButtons.vue?vue&type=script&lang=js&"
import style0 from "./RoomsRatesButtons.vue?vue&type=style&index=0&id=03d310da&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03d310da')) {
      api.createRecord('03d310da', component.options)
    } else {
      api.reload('03d310da', component.options)
    }
    module.hot.accept("./RoomsRatesButtons.vue?vue&type=template&id=03d310da&", function () {
      api.rerender('03d310da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/hotels/hotel/RoomsRatesButtons.vue"
export default component.exports